module.exports = __webpack_public_path__ + "static/media/icon-print-off.520771fd.svg";